import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "ai-chat-settings-page" };
const _hoisted_2 = { class: "tab-content" };
const _hoisted_3 = { class: "instruction-cell-wrapper" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "tab-content" };
const _hoisted_6 = { class: "tab-content test-chat-section" };
const _hoisted_7 = { class: "chat-container" };
const _hoisted_8 = { class: "form-group" };
const _hoisted_9 = { class: "chat-display" };
const _hoisted_10 = { class: "chat-input-group" };
const _hoisted_11 = { class: "button-row" };
const _hoisted_12 = {
    key: 0,
    class: "instruction-preview"
};
const _hoisted_13 = {
    key: 1,
    class: "instruction-preview"
};
const _hoisted_14 = {
    key: 0,
    class: "instruction-preview"
};
import { ref, onMounted, useTemplateRef } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import AdminTable from '../components/AdminTable.vue';
import MGDialog from '@/components/elements/MGDialog.vue';
import MGButton from '@/components/elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AIChatSettingsPage',
    setup(__props) {
        const admin = useAdmin();
        const preloadsTable = useTemplateRef('preloadsTable');
        const contextsTable = useTemplateRef('contextsTable');
        const activeTab = ref('preloads');
        const expandedInstructions = ref([]);
        // Dialog state
        const showDeletePreloadDialog = ref(false);
        const showDeleteContextDialog = ref(false);
        const itemToDelete = ref(null);
        const deleteType = ref(null);
        // Pre Load Instructions
        const preloads = ref([]);
        const preloadsLoading = ref(false);
        const savingPreloadId = ref(null);
        const addingPreload = ref(false);
        const deletingPreloadId = ref(null);
        const preloadColumns = [
            {
                field: 'from',
                label: 'From',
                width: '150px',
                sortable: true,
                editable: true,
                type: 'text',
                required: true,
                placeholder: 'System'
            },
            {
                field: 'instruction',
                label: 'Instruction',
                width: '3fr',
                sortable: false,
                editable: true,
                type: 'textarea',
                required: true,
                placeholder: 'Enter instruction...'
            }
        ];
        // Context Hints
        const contexts = ref([]);
        const contextsLoading = ref(false);
        const savingContextId = ref(null);
        const addingContext = ref(false);
        const deletingContextId = ref(null);
        const contextColumns = [
            {
                field: 'keyWords',
                label: 'Keywords',
                width: '200px',
                sortable: true,
                editable: true,
                type: 'text',
                required: true,
                placeholder: 'Keywords'
            },
            {
                field: 'cta',
                label: 'CTA',
                width: '2fr',
                sortable: false,
                editable: true,
                type: 'text',
                required: true,
                placeholder: 'Call to action'
            },
            {
                field: 'appScreen',
                label: 'App Screen',
                width: '200px',
                sortable: true,
                editable: true,
                type: 'text',
                required: false,
                placeholder: 'Screen name'
            },
            {
                field: 'cmsPage',
                label: 'CMS Page',
                width: '200px',
                sortable: true,
                editable: true,
                type: 'text',
                required: false,
                placeholder: 'CMS page'
            },
            {
                field: 'externalUrl',
                label: 'External URL',
                width: '200px',
                sortable: false,
                editable: true,
                type: 'url',
                required: false,
                placeholder: 'https://...'
            }
        ];
        // Test Chat
        const message = ref({ body: "", providerOverride: "OpenAI" });
        const self = ref(null);
        const chatResponse = ref("");
        const loading = ref(false);
        // Text expansion for mobile
        function isInstructionExpanded(rowId) {
            return expandedInstructions.value.includes(rowId);
        }
        function toggleInstruction(rowId) {
            const index = expandedInstructions.value.indexOf(rowId);
            if (index > -1) {
                expandedInstructions.value.splice(index, 1);
            }
            else {
                expandedInstructions.value.push(rowId);
            }
        }
        function isTruncatable(text) {
            if (!text)
                return false;
            const lineCount = (text.match(/\n/g) || []).length + 1;
            return lineCount > 3 || text.length > 150;
        }
        // Pre Load Instructions
        function getPreLoadInstructions() {
            preloadsLoading.value = true;
            admin.getPreLoadInstructions((result) => {
                preloads.value = result;
                preloadsLoading.value = false;
            });
        }
        function handlePreloadAdd(data) {
            console.log('handlePreloadAdd called, setting addingPreload to true');
            addingPreload.value = true;
            console.log('addingPreload is now:', addingPreload.value);
            admin.createPreLoadInstruction(data, () => {
                getPreLoadInstructions();
                preloadsTable.value?.resetAddRow();
                addingPreload.value = false;
            }, (error) => {
                console.error('Error adding pre-load instruction:', error);
                addingPreload.value = false;
            });
        }
        function handlePreloadEditSave({ rowId, data }) {
            savingPreloadId.value = rowId;
            admin.updatePreLoadInstruction(rowId, data, () => {
                getPreLoadInstructions();
                preloadsTable.value?.cancelEdit();
                savingPreloadId.value = null;
            }, (error) => {
                console.error('Error saving pre-load instruction:', error);
                savingPreloadId.value = null;
            });
        }
        function handlePreloadDelete(row) {
            itemToDelete.value = row;
            deleteType.value = 'preload';
            showDeletePreloadDialog.value = true;
        }
        function confirmDeletePreload() {
            if (!itemToDelete.value)
                return;
            const idToDelete = itemToDelete.value.id;
            showDeletePreloadDialog.value = false;
            deletingPreloadId.value = idToDelete;
            admin.deletePreLoadInstruction(idToDelete, () => {
                getPreLoadInstructions();
                itemToDelete.value = null;
                deletingPreloadId.value = null;
            }, (error) => {
                console.error('Error deleting pre-load instruction:', error);
                deletingPreloadId.value = null;
            });
        }
        function cancelDeletePreload() {
            showDeletePreloadDialog.value = false;
            itemToDelete.value = null;
        }
        // Context Hints
        function getContextAppActions() {
            contextsLoading.value = true;
            admin.getContextAppActions((result) => {
                contexts.value = result;
                contextsLoading.value = false;
            });
        }
        function handleContextAdd(data) {
            addingContext.value = true;
            admin.createContextAppAction(data, () => {
                getContextAppActions();
                contextsTable.value?.resetAddRow();
                addingContext.value = false;
            }, (error) => {
                console.error('Error adding context hint:', error);
                addingContext.value = false;
            });
        }
        function handleContextEditSave({ rowId, data }) {
            savingContextId.value = rowId;
            admin.updateContextAppAction(rowId, data, () => {
                getContextAppActions();
                contextsTable.value?.cancelEdit();
                savingContextId.value = null;
            }, (error) => {
                console.error('Error saving context hint:', error);
                savingContextId.value = null;
            });
        }
        function handleContextDelete(row) {
            itemToDelete.value = row;
            deleteType.value = 'context';
            showDeleteContextDialog.value = true;
        }
        function confirmDeleteContext() {
            if (!itemToDelete.value)
                return;
            const idToDelete = itemToDelete.value.id;
            showDeleteContextDialog.value = false;
            deletingContextId.value = idToDelete;
            admin.deleteContextAppAction(idToDelete, () => {
                getContextAppActions();
                itemToDelete.value = null;
                deletingContextId.value = null;
            }, (error) => {
                console.error('Error deleting context hint:', error);
                deletingContextId.value = null;
            });
        }
        function cancelDeleteContext() {
            showDeleteContextDialog.value = false;
            itemToDelete.value = null;
        }
        // Test Chat
        function sendMessage() {
            if (!message.value.body || !self.value)
                return;
            loading.value = true;
            chatResponse.value = "Please wait . . .";
            admin.sendChatMessage(self.value.id, message.value, (result) => {
                chatResponse.value = result.body;
                loading.value = false;
            }, (error) => {
                chatResponse.value = `Error: ${error}`;
                loading.value = false;
            });
        }
        onMounted(() => {
            admin.getSelf((result) => {
                self.value = result;
            });
            getPreLoadInstructions();
            getContextAppActions();
        });
        return (_ctx, _cache) => {
            const _component_v_tab = _resolveComponent("v-tab");
            const _component_v_tabs = _resolveComponent("v-tabs");
            const _component_v_window_item = _resolveComponent("v-window-item");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_window = _resolveComponent("v-window");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_tabs, {
                    class: "no-uppercase-tabs",
                    modelValue: activeTab.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((activeTab).value = $event)),
                    "align-tabs": "start",
                    color: "primary"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_tab, { value: "preloads" }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createElementVNode("span", { class: "tab-icon" }, "📋", -1),
                                _createTextVNode(" Pre Load Instructions ")
                            ])),
                            _: 1
                        }),
                        _createVNode(_component_v_tab, { value: "contexts" }, {
                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createElementVNode("span", { class: "tab-icon" }, "🔗", -1),
                                _createTextVNode(" Context Hints ")
                            ])),
                            _: 1
                        }),
                        _createVNode(_component_v_tab, { value: "test-chat" }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createElementVNode("span", { class: "tab-icon" }, "💬", -1),
                                _createTextVNode(" Test Chat ")
                            ])),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_window, {
                    modelValue: activeTab.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((activeTab).value = $event))
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_window_item, { value: "preloads" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(AdminTable, {
                                        ref_key: "preloadsTable",
                                        ref: preloadsTable,
                                        title: "Pre Load Instructions",
                                        icon: "📋",
                                        columns: preloadColumns,
                                        data: preloads.value,
                                        loading: preloadsLoading.value,
                                        "saving-row-id": savingPreloadId.value,
                                        "adding-row": addingPreload.value,
                                        "deleting-row-id": deletingPreloadId.value,
                                        searchable: true,
                                        "search-placeholder": "Search instructions...",
                                        editable: true,
                                        deletable: true,
                                        addable: true,
                                        "empty-message": "No pre-load instructions configured.",
                                        onRowEditSave: handlePreloadEditSave,
                                        onRowDelete: handlePreloadDelete,
                                        onRowAdd: handlePreloadAdd
                                    }, {
                                        "cell-instruction": _withCtx(({ row }) => [
                                            _createElementVNode("div", _hoisted_3, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass({ 'truncated': !isInstructionExpanded(row.id) && isTruncatable(row.instruction) })
                                                }, _toDisplayString(row.instruction), 3),
                                                (isTruncatable(row.instruction))
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "more-less-btn",
                                                        onClick: _withModifiers(($event) => (toggleInstruction(row.id)), ["stop"])
                                                    }, _toDisplayString(isInstructionExpanded(row.id) ? '[less]' : '[more]'), 9, _hoisted_4))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["data", "loading", "saving-row-id", "adding-row", "deleting-row-id"])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: "contexts" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(AdminTable, {
                                        ref_key: "contextsTable",
                                        ref: contextsTable,
                                        title: "Context Hints",
                                        icon: "🔗",
                                        columns: contextColumns,
                                        data: contexts.value,
                                        loading: contextsLoading.value,
                                        "saving-row-id": savingContextId.value,
                                        "adding-row": addingContext.value,
                                        "deleting-row-id": deletingContextId.value,
                                        searchable: true,
                                        "search-placeholder": "Search context hints...",
                                        editable: true,
                                        deletable: true,
                                        addable: true,
                                        "empty-message": "No context hints configured.",
                                        onRowEditSave: handleContextEditSave,
                                        onRowDelete: handleContextDelete,
                                        onRowAdd: handleContextAdd
                                    }, null, 8, ["data", "loading", "saving-row-id", "adding-row", "deleting-row-id"])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: "test-chat" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Test Chat MG", -1)),
                                        _createElementVNode("div", _hoisted_8, [
                                            _cache[10] || (_cache[10] = _createElementVNode("label", null, "Provider:", -1)),
                                            _createVNode(_component_v_text_field, {
                                                modelValue: message.value.providerOverride,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((message.value.providerOverride) = $event)),
                                                variant: "outlined",
                                                density: "compact",
                                                placeholder: "OpenAI"
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createVNode(_component_v_textarea, {
                                                modelValue: chatResponse.value,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((chatResponse).value = $event)),
                                                variant: "outlined",
                                                readonly: "",
                                                rows: "15",
                                                class: "chat-output",
                                                placeholder: "Response will appear here..."
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createVNode(_component_v_textarea, {
                                                modelValue: message.value.body,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((message.value.body) = $event)),
                                                variant: "outlined",
                                                rows: "3",
                                                placeholder: "Enter your message...",
                                                class: "chat-input"
                                            }, null, 8, ["modelValue"]),
                                            _createElementVNode("div", _hoisted_11, [
                                                _createVNode(MGButton, {
                                                    text: "Send",
                                                    onClick: sendMessage,
                                                    disabled: !message.value.body || loading.value,
                                                    small: true,
                                                    class: "send-button"
                                                }, null, 8, ["disabled"])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showDeletePreloadDialog.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((showDeletePreloadDialog).value = $event)),
                    title: "Delete Pre-Load Instruction",
                    "max-width": "400px",
                    persistent: true
                }, {
                    content: _withCtx(() => [
                        _cache[14] || (_cache[14] = _createElementVNode("p", null, "Are you sure you want to delete this pre-load instruction?", -1)),
                        (itemToDelete.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                _cache[12] || (_cache[12] = _createElementVNode("strong", null, "From:", -1)),
                                _createTextVNode(" " + _toDisplayString(itemToDelete.value.from), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (itemToDelete.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                                _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Instruction:", -1)),
                                _createTextVNode(" " + _toDisplayString(itemToDelete.value.instruction), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Delete",
                            onClick: confirmDeletePreload,
                            stacked: true,
                            outline: ""
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            onClick: cancelDeletePreload,
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showDeleteContextDialog.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((showDeleteContextDialog).value = $event)),
                    title: "Delete Context Hint",
                    "max-width": "400px",
                    persistent: true
                }, {
                    content: _withCtx(() => [
                        _cache[16] || (_cache[16] = _createElementVNode("p", null, "Are you sure you want to delete this context hint?", -1)),
                        (itemToDelete.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                _cache[15] || (_cache[15] = _createElementVNode("strong", null, "Keywords:", -1)),
                                _createTextVNode(" " + _toDisplayString(itemToDelete.value.keyWords), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Delete",
                            onClick: confirmDeleteContext,
                            stacked: true,
                            outline: ""
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            onClick: cancelDeleteContext,
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
